import './bootstrap';
import '../css/public-theme.css';
import '../css/themes.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from './router';
import i18n from './i18n';
import App from './App.vue';
import { initTheme } from './utils/theme';
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

/* add icons to the library */
library.add(fas, far);

initTheme();

// Create Pinia store
const pinia = createPinia();

// Create Vue app
const app = createApp(App);

// Register Font Awesome component globally
app.component('font-awesome-icon', FontAwesomeIcon);

// Use plugins
app.use(pinia);
app.use(router);
app.use(i18n);
app.use(ToastPlugin);

// Mount app
app.mount('#app');
